import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import usePatient from '~/utils/patient/hook';
import { UncontrolledTable } from '~/components';
import { format } from 'date-fns';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import NoteCell from '~/components/Patient/Identity/NoteCell';
import { MatchStatus } from '~/utils/const/identity';

const IdentitySurgeries = ({
  includeFilters,
  allData,
}) => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="identity-surgeries"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-surgery',
        params: {
          'all-data': allData ? '1' : null,
          sacwisId,
          match_status_id: MatchStatus.Approved,
          ...includeFilters && {
            'surgerydateDt__<<': format(new Date(), 'MM/DD/YYYY'),
          },
        },
      }}
      defaultSorted={[{ id: includeFilters ? 'surgerydateDt__>>' : 'surgerydateDt', desc: true }]}
      columns={[
        {
          id: 'surgery',
          Header: 'Surgery',
          accessor: 'attributes.surgery',
        },
        {
          id: includeFilters ? 'surgerydateDt__>>' : 'surgerydateDt',
          Header: 'Surgery Date',
          accessor: 'attributes.surgerydateDt',
          cellType: 'date',
          ...includeFilters && {
            Filter: d => <TableFilterDateRange {...d} />,
          },
        },
        {
          id: 'preopdx',
          Header: 'Pre-surgery Diagnosis',
          accessor: 'attributes.preopdx',
        },
        {
          id: 'service',
          Header: 'Specialist',
          accessor: 'attributes.service',
        },
        {
          id: 'postopdx',
          Header: 'Post-surgery Diagnosis',
          accessor: 'attributes.postopdx',
        },
        {
          id: 'primarydx',
          Header: 'Primary Diagnosis',
          accessor: 'attributes.primarydx',
        },
        {
          id: 'sourceDescription',
          Header: 'Reporting Healthcare Insitution',
          accessor: 'attributes.sourceDescription',
          ...includeFilters && {
            Filter: d => <TableFilterIdentitySource {...d} />,
          },
        },
        {
          id: 'hasNotes',
          Header: 'Notes',
          accessor: 'attributes.hasNotes',
          filterable: false,
          Cell: n => <NoteCell {...n} params={{ notetype__like: 'Postop Note' }} />,
        },
      ]}
      SubComponent={({ original: row }) => (
        <div className="p-3">
          <Row>
            <Col sm={2}>
              <h6 className="text-primary">Location</h6>
              {row.attributes.actuallocname}
            </Col>

            <Col sm>
              <h6 className="text-primary">Service</h6>
              {row.attributes.service}
            </Col>
          </Row>
        </div>
      )}
    />
  );
};

IdentitySurgeries.propTypes = {
  includeFilters: PropTypes.bool,
  allData: PropTypes.bool,
};

IdentitySurgeries.defaultProps = {
  includeFilters: false,
  allData: false,
};

export default IdentitySurgeries;
